export const environment = {
  production: false,
  config: 'assets/config/config.json'
};
